import { Box, Typography } from '@mui/material'

import { FloorPreservationToggleProps } from 'models/visualStaging/virtualStagingTypes'
import { GRAY_900 } from 'constants/styling/theme'
import { MUISwitch } from 'components/common/MUISwitch'
import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * FloorPreservationToggle component for Virtual Staging.
 * Matches Figma design with toggle styling.
 * Toggle switch component for "Keep floor untouched" option.
 * 
 * @example
 * <FloorPreservationToggle
 *   keepFloorUntouched={virtualStagingState.keepFloorUntouched}
 *   onToggle={handleFloorToggle}
 *   isDisabled={virtualStagingState.isGeneratingStaging}
 * />
 */
export const FloorPreservationToggle: React.FC<FloorPreservationToggleProps> = ({
  keepFloorUntouched,
  onToggle,
  isDisabled = false,
}) => {
  const { t } = useTranslation(['photo_studio_editing'])

  const handleToggle = () => {
    if (!isDisabled) {
      onToggle(!keepFloorUntouched)
    }
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Typography
        sx={{
          fontSize: '1.6rem',
          fontWeight: 550,
          color: GRAY_900,
          lineHeight: 1.5,
          letterSpacing: '-0.64px',
        }}
      >
        {t('virtual_staging.floor_preservation.title')}
      </Typography>
      <MUISwitch
        checked={keepFloorUntouched}
        onChange={handleToggle}
        disabled={isDisabled}
        size="medium"
      />
    </Box>
  )
}
